import React, { useState, useEffect } from 'react';
import SingleSelectField from '@grnhse/seedling/lib/birch/components/forms/fields/single_select_field';
import TextAreaField from '@grnhse/seedling/lib/birch/components/forms/fields/text_area_field';
import CheckboxField from '@grnhse/seedling/lib/birch/components/forms/fields/checkbox_field';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { withLocalePrefix } from 'shared/utils/translation';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { RejectModalOptionsResponse } from 'candidate_profile_redesign/shared/types';

const t = withLocalePrefix('talent_matching.bulk_actions.reject');

interface Props {
  rejectionData: RejectModalOptionsResponse;
  asSpam: boolean;
}

const RejectionReasonFields = ({ rejectionData, asSpam }: Props) => {
  const [showSpamWarning, setShowSpamWarning] = useState(false);
  const { watch } = useFormContext();
  const rejectionReason = watch('rejection_reason');

  const spamReasonId = rejectionData?.rejectionReasons?.spamReason;

  useEffect(() => {
    if (rejectionReason?.value === spamReasonId) {
      setShowSpamWarning(true);
    } else {
      setShowSpamWarning(false);
    }
  }, [rejectionReason, spamReasonId]);

  return (
    <Stack>
      <SingleSelectField
        name="rejection_reason"
        label={t('labels.reason')}
        items={rejectionData.rejectionReasons.rejectionOptions}
        rules={{ required: t('labels.reason_required') }}
        helperText={showSpamWarning ? t('spam_warning') : undefined}
        disabled={asSpam}
      />
      <TextAreaField name="note" label={t('labels.note')} />
      <CheckboxField
        name="send_email"
        label={t('labels.send_email')}
        value="send_email"
      />
    </Stack>
  );
};

export default RejectionReasonFields;
